import { productFamilyIdFormat } from "@redotech/redo-model/ids";
import { AttributeSchema } from "@redotech/redo-model/inventory/attributes";
import * as z from "zod/v4";

export const updateProductFamily = {
  name: "updateProductFamily" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    title: z.string().optional(),
    description: z.string().optional(),
    vendor: z.string().nullable().optional(),
    attributes: z.array(AttributeSchema).optional(),
  }),
  output: z.object({
    success: z.boolean(),
  }),
};
